module.exports = __webpack_public_path__ + "img/star-active.f1b4db8b.png";